import {Collapse, Tag, Empty} from "antd";
import className from "classnames/bind";
import style from "../style/SiteCrawler.module.scss";

const cn = className.bind(style);

/**
 * Vấn đề THEO TRANG (tiêu chí per-page bị 'fail': thiếu H1, thiếu meta description,
 * ảnh thiếu alt...). Gom theo LOẠI để gọn, mỗi loại liệt kê các URL mắc lỗi (bấm để
 * mở chi tiết trang). Nhãn loại lấy từ phần trước dấu ':' của message.
 */
function PageIssueList({issues, onOpenPage}) {

	// issues: mảng phẳng các item {id,type,page_id,url,message} có type bắt đầu 'page_'.
	if (!issues || issues.length === 0) {
		return <Empty description="Không có lỗi SEO theo trang 🎉" />;
	}

	// Gom theo type.
	const groups = {};

	issues.forEach((iss) => {
		const key = iss.type || 'page_other';
		if (!groups[key]) {
			// Nhãn = phần trước ':' của message đầu tiên (vd "Thẻ H1"), fallback theo type.
			const label = (iss.message || '').split(':')[0].trim() || key.replace(/^page_/, '');
			groups[key] = {label, items: []};
		}
		groups[key].items.push(iss);
	});

	// Sắp theo số trang mắc lỗi giảm dần.
	const ordered = Object.entries(groups).sort((a, b) => b[1].items.length - a[1].items.length);

	const items = ordered.map(([type, g]) => ({
		key: type,
		label: (
			<span>
				<Tag color="orange">{g.label}</Tag>
				<strong>{g.items.length}</strong> trang
			</span>
		),
		children: (
			<div>
				{g.items.map((iss) => (
					<div key={iss.id} className={cn('issueItem')}>
						<span className={cn('issueLink')} onClick={() => iss.page_id && onOpenPage?.(iss.page_id)}>
							{iss.url || `Trang #${iss.page_id}`}
						</span>
						<div className={cn('issueMeta')}>{iss.message}</div>
					</div>
				))}
			</div>
		),
	}));

	return <Collapse items={items} />;
}

export default PageIssueList;
